import getConfig from 'next/config';

const environment = {
  production: 'production',
  development: 'development',
  staging: 'staging',
  locust: 'locust',
} as const;

export interface AppConfig {
  apiHost: string;
  participantGatewayApiHost: string;
  monolithUrl: string;
  demoEventId: string;
  demoEventToken: string;
  environment: typeof environment[keyof typeof environment];
}

export interface NextConfig {
  publicRuntimeConfig: AppConfig;
}

export const getPublicRuntimeConfig = (): AppConfig => {
  return (getConfig() as NextConfig).publicRuntimeConfig;
};
